import React from 'react';
import { artUrl } from '../../cardArt';

// Renders a single self-contained Neapolitan card image (v3 asset pack).
// The frame/border is baked into the PNG, so no app-drawn template is used.
// The image keeps its native aspect ratio (object-contain, no crop/stretch).
export default function CardFace({ card, sizeClass = 'w-full', felt = false }) {
  const { suit, value } = card;
  return (
    <div
      className={`${sizeClass} relative`}
      style={{
        borderRadius: '7%',
        filter: felt
          ? 'drop-shadow(0 10px 20px rgba(0,0,0,0.45))'
          : 'drop-shadow(0 8px 16px rgba(0,0,0,0.28))',
      }}
    >
      <img
        src={artUrl(suit, value)}
        alt=""
        aria-hidden="true"
        style={{ display: 'block', width: '100%', height: 'auto' }}
        draggable={false}
      />
    </div>
  );
}
